var _path, _path2, _radialGradient, _path3, _path4, _path5, _radialGradient2, _radialGradient3, _path6, _path7, _path8, _radialGradient4, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHungaryOtoslotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 52.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.03 40.88c-6.3 6.84-17.63 4.08-20.35-4.63-6.06.42-11.53-3.85-12.64-9.84-2.31-12.43 13.37-19.5 21.17-9.94a7.208 7.208 0 0 1 2.42-4.6c-.76-2.69 2.2-4.74 4.64-3.69 2.07-.89 4.66.41 4.75 2.75l7.98.01c.09-2.36 2.72-3.65 4.76-2.76 2.05-.89 4.72.41 4.76 2.83 3.13-2.01 10.24-.55 10.3 3.09.02 1.06-.66 1.67-1.28 2.42 1.36 1.84 1.26 4.42-.23 6.16.28-.13.6-.2.93-.2h20.78a2.31 2.31 0 0 1 2.29 2.22c.5-.38 1.04-.7 1.62-.97v-1.17c0-1.26 1.03-2.3 2.29-2.3h2.69c1.25 0 2.29 1.04 2.29 2.3v1.06c4.54 2.05 6.58 6.8 5.83 11.59-.74 4.79-4.21 8.89-9.31 8.89-3.85 0-6.86-2.44-8.38-5.87v3.49c0 1.26-1.04 2.3-2.29 2.3H74.7c-1.26 0-2.29-1.04-2.29-2.3v-9.49H71v9.49c0 1.26-1.04 2.3-2.29 2.3h-4.36c-1.26 0-2.29-1.04-2.29-2.3v-4.87c-1.23 4.06-4.73 7.22-9.07 7.22-1.94 0-3.8-.66-5.36-1.82-.35.86-1.19 1.44-2.12 1.44h-9.19c-1.25 0-2.29-1.04-2.29-2.3v-.51z",
    fill: "#2c935b"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#1a5926"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.51 39.14c-5.65 7.23-17 4.23-18.68-4.57-6.45 1.21-12.47-3.75-12.47-10.41 0-5.85 4.71-10.59 10.53-10.59 5.12 0 9.39 3.69 10.34 8.57 9.46-1.83 16.36 9.22 10.28 17z",
    style: {
      fillRule: "evenodd"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.32 24.04h5.06c.42 0 .76.34.76.77v10.74h3.01c-.14-.66-.21-1.35-.21-2.06 0-2.49.89-4.74 2.32-6.38 1.46-1.66 3.48-2.69 5.72-2.69s4.26 1.03 5.72 2.69c1.44 1.64 2.32 3.89 2.32 6.38s-.89 4.74-2.32 6.38c-1.46 1.66-3.48 2.69-5.72 2.69s-4.26-1.03-5.72-2.69c-.37-.42-.7-.89-1-1.39v2.94a.77.77 0 0 1-.76.77h-9.19c-.42 0-.76-.34-.76-.77V24.8c.01-.42.35-.76.77-.76zm24.92 0h20.78c.42 0 .76.34.76.77v4.13c.96-1.96 2.58-3.48 4.67-4.15v-2.21a.77.77 0 0 1 .76-.77h2.69c.42 0 .76.34.76.77v2.11c9.47 3.18 6.87 17.9-1.95 17.9-5.8 0-8.97-6.63-7.59-11.88-.04 0-.08.01-.12.01h-2.19v11.03a.77.77 0 0 1-.76.77H74.7c-.42 0-.76-.34-.76-.77V30.71h-4.47v11.03a.77.77 0 0 1-.76.77h-4.36c-.42 0-.76-.34-.76-.77V30.71h-2.34c-.42 0-.76-.34-.76-.77V24.8c-.01-.42.33-.76.75-.76zm-8.25 6.8c-.44 0-.86.26-1.18.69-.36.49-.59 1.18-.59 1.95 0 .78.23 1.47.59 1.96.31.43.73.69 1.18.69.44 0 .86-.26 1.18-.69.36-.49.59-1.18.59-1.96 0-.77-.23-1.46-.59-1.95-.32-.43-.74-.69-1.18-.69zm36.74.02c-.43 0-.84.26-1.15.68-.78 1.06-.78 2.86 0 3.92.31.42.72.69 1.15.69.44 0 .84-.26 1.15-.69.78-1.06.78-2.86 0-3.92-.31-.41-.71-.68-1.15-.68z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M36.32 24.8h5.06v11.51h4.12v5.1h-9.19V24.8zm24.92 0H71.3v5.14h-2.59v11.79h-4.36V29.94h-3.11zm10.72 0h10.06v5.14h-2.96v11.79H74.7V29.94h-2.74zm-18.97.37c-4.02 0-7.28 3.72-7.28 8.3 0 4.59 3.26 8.31 7.28 8.31s7.28-3.72 7.28-8.31c-.01-4.58-3.26-8.3-7.28-8.3zm0 4.9c-1.4 0-2.53 1.53-2.53 3.41 0 1.89 1.13 3.41 2.53 3.41s2.53-1.53 2.53-3.41c-.01-1.89-1.14-3.41-2.53-3.41zm35.23-4.7c-3.28.77-5.67 3.84-5.67 8.14s3.22 8.3 7.18 8.3c3.97 0 7.18-3.86 7.18-8.3s-2.35-7.25-6-8.26v-2.67h-2.69v2.79zm1.51 4.72c-1.38 0-2.5 1.53-2.5 3.41s1.12 3.41 2.5 3.41 2.5-1.53 2.5-3.41-1.12-3.41-2.5-3.41z",
    fill: "#fff",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 29.319,
    cy: 31.875,
    r: 12.054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6b9689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.111,
    stopColor: "#628e81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#48796a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    stopColor: "#386c5c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.454,
    stopColor: "#326856"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#215941"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.864,
    stopColor: "#1a5439"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.11 25.01c4.16 3.29 4.88 9.35 1.61 13.53s-9.29 4.91-13.45 1.62-4.88-9.35-1.61-13.53 9.29-4.91 13.45-1.62z",
    fill: "url(#a)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4 29.24c2.81 2.22 3.3 6.31 1.09 9.14-2.21 2.82-6.27 3.31-9.08 1.09s-3.29-6.31-1.09-9.14a6.443 6.443 0 0 1 9.08-1.09z",
    fill: "#e8eeec"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#1f1f1f"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m21.15 33.8-2.46.97 1.5 1.02 3.54-1.48a2.48 2.48 0 0 0 1.11-.94c.84-1.26.45-2.64-.76-3.47-2.74-1.84-5.42 1.9-2.93 3.9zm2.39-1.32c-.72 1.06-2.32-.04-1.63-1.11.72-1.04 2.33.04 1.63 1.11z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m29.41 36.74-1.02 1.52c-1.89 2.82-6.12-.05-4.23-2.87l1.02-1.52c1.88-2.82 6.11.06 4.23 2.87zm-1.29-1.18-1.31 1.95c-.62.92-2-.02-1.38-.94l1.31-1.95c.62-.92 2 .02 1.38.94z",
    style: {
      fillRule: "evenodd"
    }
  })), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 30.263,
    cy: 32.588,
    r: 2.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#fff",
    stopOpacity: 0.456
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.2
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M31.9 30.5c1.15.91 1.35 2.58.44 3.73a2.64 2.64 0 0 1-3.71.45 2.656 2.656 0 0 1-.44-3.73c.9-1.16 2.56-1.36 3.71-.45z",
    fill: "url(#b)",
    style: {
      fillRule: "evenodd"
    }
  }), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 14.476,
    cy: 20.626,
    r: 7.102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.209,
    stopColor: "#fee281"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.393,
    stopColor: "#fee17d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#fedf70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.789,
    stopColor: "#fddb5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.991,
    stopColor: "#fdd53d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdd53c"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fillRule: "evenodd"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.84 14.55c5.29 0 9.58 4.32 9.58 9.64s-4.29 9.64-9.58 9.64-9.58-4.32-9.58-9.64 4.29-9.64 9.58-9.64z",
    fill: "url(#c)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.97 19.32c3.57 0 6.47 2.91 6.47 6.51s-2.9 6.51-6.47 6.51-6.47-2.91-6.47-6.51 2.9-6.51 6.47-6.51z",
    fill: "#fef6d3"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m11.35 22.93 4.06-1.53.55 1.32-2.83 1.07.22 1.51c1.88-1.23 3.66-.38 4.31 1.18 1.31 3.12-3.61 5.53-5.67 2.79l1.73-.65c1.15.92 2.91-.13 2.35-1.47-.49-1.18-2-1.08-2.57.13l-1.45.24-.7-4.59z",
    fill: "#1f1f1f"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 15.4,
    cy: 20.841,
    r: 2.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.147,
    stopColor: "#fff",
    stopOpacity: 0.927
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 18.18c1.46 0 2.64 1.19 2.64 2.66s-1.18 2.66-2.64 2.66-2.64-1.19-2.64-2.66 1.18-2.66 2.64-2.66z",
    fill: "url(#d)",
    style: {
      fillRule: "evenodd"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9 9.86c.93.74.74 2.03-.26 2.59a5.52 5.52 0 0 1 1.8 1.7v-.91a.77.77 0 0 1 .76-.77h7.48c.42 0 .76.34.76.77v.48l.28-.32c.42-.44.91-.81 1.45-1.08-.02-.01-.03-.03-.05-.04-.37-.3-.6-.73-.6-1.21s.23-.91.6-1.21c.32-.26.76-.42 1.23-.42s.91.16 1.23.42c.06.05.11.09.16.15l.16-.15c.32-.26.76-.42 1.23-.42s.91.16 1.23.42c.37.3.6.73.6 1.21s-.23.91-.6 1.21c-.08.07-.17.12-.26.17a5.52 5.52 0 0 1 1.2.95c.2.21.39.44.56.68 1.34-3.51 7.1-3.1 9.22-.44.25.28.26.7.02 1l-1.64 2a3.39 3.39 0 0 1 1.44 3.51c-.41 1.97-2.23 2.99-4.14 2.97-1.89-.02-3.76-.94-4.92-2.45-1 1.41-2.58 2.28-4.32 2.28-3.4 0-5.8-3.2-5.29-6.48h-1.19v5.84a.77.77 0 0 1-.76.77h-2.67c-.42 0-.76-.34-.76-.77v-5.84h-1.51c.5 3.28-1.89 6.48-5.3 6.48-3.04 0-5.36-2.6-5.36-5.6 0-2.1 1.14-4.07 3.01-5.03a.218.218 0 0 0-.05-.04c-.8-.65-.8-1.77 0-2.42.76-.61 1.95-.56 2.63.15.68-.71 1.87-.76 2.63-.15zm14.63 5.93c-1.57 0-1.47 3.04 0 3.04 1.48 0 1.57-3.04 0-3.04zm-17.49 0c-1.53 0-1.53 3.04 0 3.04s1.53-3.04 0-3.04z",
    fill: "#1a5926"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.21 13.24h7.48v2.45h-2.4v6.61h-2.68v-6.61h-2.4zm23.66 2.94 1.68-2.04c-2.02-2.58-7.49-2.54-8.09.73-.31 1.71 1.07 2.59 2.81 3.2.39.14 2.67.61 2.16 1.35-.54.79-2.89-.91-3.26-1.28l-1.78 1.96c1.08 1.46 2.82 2.22 4.4 2.24 3.79.04 4.66-4.23 1.57-5.44-1.35-.53-2.8-.9-2.7-1.5.08-.61 1.51-.44 3.21.78zm-11.34-3.66c2.54 0 4.6 2.16 4.6 4.83s-2.06 4.83-4.6 4.83-4.6-2.16-4.6-4.83c.01-2.67 2.07-4.83 4.6-4.83zm0 2.5c1.06 0 1.93 1.02 1.93 2.29s-.86 2.29-1.93 2.29-1.93-1.02-1.93-2.29c.01-1.26.87-2.29 1.93-2.29zm-1.16-4.82c.59 0 1.07.38 1.07.86s-.48.86-1.07.86c-.6 0-1.07-.39-1.07-.86-.01-.47.47-.86 1.07-.86zm2.79 0c.59 0 1.07.38 1.07.86s-.48.86-1.07.86-1.07-.39-1.07-.86c-.01-.47.48-.86 1.07-.86zm-19.12 2.32c2.54 0 4.6 2.16 4.6 4.83s-2.06 4.83-4.6 4.83-4.6-2.16-4.6-4.83 2.06-4.83 4.6-4.83zm0 2.5c1.06 0 1.93 1.02 1.93 2.29s-.86 2.29-1.93 2.29c-1.06 0-1.92-1.02-1.92-2.29 0-1.26.86-2.29 1.92-2.29zm-1.17-4.82c.6 0 1.07.38 1.07.86s-.48.86-1.07.86-1.07-.39-1.07-.86.48-.86 1.07-.86zm2.79 0c.6 0 1.07.38 1.07.86s-.48.86-1.07.86-1.07-.39-1.07-.86.48-.86 1.07-.86z",
    fill: "#fdd131",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHungaryOtoslotto);
export default __webpack_public_path__ + "static/media/hungary_otoslotto.ec180abf73c217afae32a93e25e2b13e.svg";
export { ForwardRef as ReactComponent };